import React from "react";

type Props = {
  children?: React.ReactNode;
  className?: string;
};

export default function TableContainer({ children, className }: Props) {
  return <div className={`border bg-white dark:bg-gray-800 dark:border-gray-700 rounded-t-3xl ${className}`}>{children}</div>;
}
